module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_pages_remoteEntry_mjs_098aa4d9__;